import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import logo from "../../assets/images/logo.jpg";
import SidebarContent from "./SidebarContent";
import { Container } from "reactstrap";
import { Menu as MenuIcon, X as CloseIcon } from "lucide-react";

const Sidebar = ({ isCollapsed, setIsCollapsed }) => {
  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  }, []);

  return (
    <aside
      className={`fixed left-0 top-0 h-screen bg-white border-r border-gray-200 shadow-sm flex flex-col z-50 transition-all duration-300 ${
        isCollapsed ? "w-[60px]" : "w-[240px]"
      }`}
      style={{ minWidth: isCollapsed ? 60 : 240 }}
    >
      <div className="flex items-center justify-between h-16 border-b border-gray-200 bg-gray-50 px-2">
        {!isCollapsed && (
          <Link to="/" className="flex items-center gap-2">
            <img src={logo} alt="Logo" className="h-10 w-auto" />
            <span className="font-bold text-xl text-green-600">RentalShop</span>
          </Link>
        )}
        <button
          className={`p-2 rounded hover:bg-gray-200 transition ${isCollapsed ? 'ml-0' : 'ml-auto'}`}
          onClick={() => setIsCollapsed((v) => !v)}
        >
          {isCollapsed ? <MenuIcon size={20} /> : <CloseIcon size={20} />}
        </button>
      </div>
      <SimpleBar className="flex-1 overflow-y-auto">
        <Container fluid className="p-0">
          <ul className="flex flex-col gap-1 py-4" id="navbar-nav">
            <SidebarContent isCollapsed={isCollapsed} />
          </ul>
        </Container>
      </SimpleBar>
      <div className="vertical-overlay"></div>
    </aside>
  );
};

export default Sidebar;
